import React, { useEffect, useState } from "react";
import { database } from "./firebase";
import { ref, onValue, get } from "firebase/database";
import { useNavigate, useParams } from "react-router-dom";
import sfRoundedBold from "../assets/fonts/SF-Pro-Rounded-Bold.otf";
import sfRoundedMedium from "../assets/fonts/SF-Pro-Rounded-Medium.otf";
import sfRoundedLight from "../assets/fonts/SF-Pro-Rounded-Light.otf";
import sfRoundedRegular from "../assets/fonts/SF-Pro-Rounded-Regular.otf";
import moodIcon from "../assets/moodstream-icon.png";

const ACCENT = "#f700ff";
const BG_TOP = "#05050b";
const BG_BOTTOM = "#1c0930";
const PAGE_BG = `linear-gradient(180deg, ${BG_TOP} 0%, ${BG_BOTTOM} 100%)`;

const DEFAULT_AVATAR =
  "https://firebasestorage.googleapis.com/v0/b/pokefinder-9c71b.appspot.com/o/logo_img%2Fmoodsmiley.png?alt=media";

export default function Test() {
  const params = useParams();
  const navigate = useNavigate();

  const [profilepic, setprofilepic] = useState(null);
  const [name, setname] = useState(null);
  const [username, setusername] = useState(null);
  const [todisplaygallerys, settodisplaygallerys] = useState([]);
  const [loaderstate, setloaderstate] = useState(true);
  const [link, setlink] = useState(null);
  const [fontsReady, setFontsReady] = useState(false);
  const [labelsVisible, setLabelsVisible] = useState(false);

  useEffect(() => {
    document.fonts.ready.then(() => setFontsReady(true));
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;
    const root = document.getElementById("root");
    const prev = {
      htmlBg: html.style.background,
      htmlBgColor: html.style.backgroundColor,
      htmlMinH: html.style.minHeight,
      bodyBg: body.style.background,
      bodyBgColor: body.style.backgroundColor,
      bodyMinH: body.style.minHeight,
      rootBg: root?.style.background ?? "",
    };
    html.style.background = PAGE_BG;
    html.style.backgroundColor = BG_BOTTOM;
    html.style.minHeight = "100%";
    body.style.background = PAGE_BG;
    body.style.backgroundColor = BG_BOTTOM;
    body.style.minHeight = "100%";
    if (root) {
      root.style.minHeight = "100%";
      root.style.background = "transparent";
    }
    return () => {
      html.style.background = prev.htmlBg;
      html.style.backgroundColor = prev.htmlBgColor;
      html.style.minHeight = prev.htmlMinH;
      body.style.background = prev.bodyBg;
      body.style.backgroundColor = prev.bodyBgColor;
      body.style.minHeight = prev.bodyMinH;
      if (root) root.style.background = prev.rootBg;
    };
  }, []);

  useEffect(() => {
    setloaderstate(true);
    const getUserId = ref(database, "/usernames/" + params.userId);
    get(getUserId)
      .then((snap) => {
        const val = snap.val();
        if (val == null || typeof val !== "object") {
          setloaderstate(false);
          return;
        }
        const keys = Object.keys(val);
        if (!keys.length) {
          setloaderstate(false);
          return;
        }
        getData(keys[0]);
      })
      .catch((err) => {
        console.log("::::", err);
        setloaderstate(false);
      });
  }, [params.userId]);

  const getData = async (id) => {
    const starCountRef = ref(database, "/users/" + id);
    onValue(
      starCountRef,
      (snapshot) => {
        const data2 = snapshot.val();
        if (data2?.public["profile-data"]?.downloadURL) {
          setprofilepic(data2?.public["profile-data"].downloadURL);
        }
        setname(data2?.public["profile-data"]?.name);
        setusername(data2?.public["profile-data"].username);
        getLink(id, data2?.public["profile-data"]?.username);
        if (data2?.public?.showcasing) {
          getgallery2(Object.keys(data2.public.showcasing ?? {}));
        } else {
          setloaderstate(false);
        }
      },
      { onlyOnce: true }
    );
  };

  function getgallery2(gallids) {
    if (!Array.isArray(gallids) || !gallids.length) {
      setloaderstate(false);
      return;
    }
    let promisearr = [];
    gallids.map((ent) => {
      const dum = get(ref(database, "galleries/" + ent));
      promisearr.push(
        new Promise((resolve) => {
          dum.then((snapshot) => {
            resolve({ snapshot: snapshot.val(), galId: ent });
          });
        })
      );
    });
    Promise.all(promisearr)
      .then((results) => {
        let resultarr = [];
        results.forEach((ent) => {
          if (ent?.snapshot?.public?.galleryInfo) resultarr.push(ent);
        });
        resultarr.sort(
          (a, b) =>
            (b.snapshot.public.galleryInfo.latestPostTime ?? 0) -
            (a.snapshot.public.galleryInfo.latestPostTime ?? 0)
        );
        settodisplaygallerys(resultarr);
      })
      .catch((err) => {
        console.log("gallery list", err);
      })
      .finally(() => {
        setloaderstate(false);
      });
  }

  async function getLink(id, name) {
    setlink(
      `https://app.moodstream.photos/profileView?username=${name}&uid=${id}`
    );
  }

  const avatarSrc = profilepic || DEFAULT_AVATAR;
  const showContent = fontsReady && !loaderstate;

  // Trigger label transitions after content mounts — CSS transitions need
  // a rendered frame at opacity:0 before flipping to opacity:1
  useEffect(() => {
    if (showContent) {
      const t = setTimeout(() => setLabelsVisible(true), 30);
      return () => clearTimeout(t);
    }
  }, [showContent]);

  return (
    <>
      <style>{`
        @font-face {
          font-family: 'SF Pro Rounded Bold';
          src: url(${sfRoundedBold}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }
        @font-face {
          font-family: 'SF Pro Rounded Medium';
          src: url(${sfRoundedMedium}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }
        @font-face {
          font-family: 'SF Pro Rounded Regular';
          src: url(${sfRoundedRegular}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }
        @font-face {
          font-family: 'SF Pro Rounded Light';
          src: url(${sfRoundedLight}) format('opentype');
          font-weight: normal; font-style: normal; font-display: block;
        }

        @keyframes test-spin  { to { transform: rotate(360deg); } }
        @keyframes tv-fade-up {
          from { opacity: 0; transform: translateY(10px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        * { box-sizing: border-box; margin: 0; padding: 0; }

        /* ── Sticky top header ── */
        .tv-topbar {
          position: sticky;
          top: 0;
          z-index: 100;
          width: 100%;
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 14px 20px 12px;
          background: rgba(8, 0, 15, 0.8);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-bottom: 1px solid rgba(247, 0, 255, 0.12);
        }
        .tv-topbar-icon {
          width: 34px;
          height: 34px;
          border-radius: 9px;
          object-fit: cover;
          flex-shrink: 0;
        }
        .tv-topbar-title {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 16px;
          font-weight: normal;
          color: rgba(255,255,255,0.75);
          letter-spacing: 0;
          opacity: 0;
          animation: tv-fade-up 0.2s ease-out 0.05s both;
        }

        /* ── Root ── */
        .tv-root {
          min-height: 100vh;
          min-height: 100dvh;
          background: ${PAGE_BG};
          background-color: ${BG_BOTTOM};
          display: flex;
          flex-direction: column;
          align-items: center;
          color: #fff;
          font-family: 'SF Pro Rounded Medium', -apple-system, BlinkMacSystemFont, sans-serif;
          padding-bottom: 140px;
        }

        /* Content fade-in to prevent any flash */
        .tv-content {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          animation: tv-fade-up 0.3s ease-out both;
        }

        /* ── Profile header ── */
        .tv-header {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 100%;
          max-width: 420px;
          padding: 32px 24px 20px;
        }
        .tv-avatar-img {
          width: 132px;
          height: 132px;
          border-radius: 50%;
          object-fit: cover;
          display: block;
          margin-bottom: 10px;
          flex-shrink: 0;
          opacity: 0;
          transition: opacity 0.2s ease-out;
        }
        .tv-avatar-img.loaded { opacity: 1; }

        .tv-label {
          opacity: 0;
          transform: translateY(7px);
          transition: opacity 0.28s ease-out, transform 0.28s ease-out;
        }
        .tv-label.visible {
          opacity: 1;
          transform: translateY(0);
        }
        .tv-label-d1 { transition-delay: 0.05s; }
        .tv-label-d2 { transition-delay: 0.12s; }
        .tv-label-d3 { transition-delay: 0.19s; }

        .tv-display-name {
          font-family: 'SF Pro Rounded Regular', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 28px;
          font-weight: normal;
          color: #ffffff;
          letter-spacing: -0.02em;
          margin-bottom: 0;
          opacity: 0;
          animation: tv-fade-up 0.2s ease-out 0.1s both;
        }
        .tv-username {
          font-family: 'SF Pro Rounded Light', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 22px;
          font-weight: normal;
          color: rgba(255,255,255,0.5);
          letter-spacing: 0;
          margin-top: -2px;
          opacity: 0;
          animation: tv-fade-up 0.2s ease-out 0.15s both;
        }

        /* ── Stream grid ── */
        .tv-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          column-gap: 9px;
          row-gap: 12px;
          width: 100%;
          max-width: 420px;
          padding: 0 6px;
        }
        .tv-card {
          position: relative;
          border-radius: 14px;
          overflow: hidden;
          aspect-ratio: 3 / 4;
          cursor: pointer;
          background: #160025;
        }
        .tv-card-img {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          opacity: 0;
          transition: opacity 0.18s ease-out;
        }
        .tv-card-img.loaded { opacity: 1; }
        .tv-card-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(to top, rgba(0,0,0,0.82) 0%, rgba(0,0,0,0.3) 42%, transparent 68%);
          border-radius: 14px;
        }
        .tv-card-title {
          position: absolute;
          bottom: 12px;
          left: 11px;
          right: 11px;
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 21px;
          font-weight: normal;
          color: #fff;
          line-height: 1.15;
          word-break: break-word;
          overflow-wrap: break-word;
          opacity: 0;
          animation: tv-fade-up 0.18s ease-out 0.1s both;
        }

        /* ── Sticky footer ── */
        .tv-footer {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: rgba(8, 0, 15, 0.88);
          backdrop-filter: blur(20px);
          -webkit-backdrop-filter: blur(20px);
          border-top: 1px solid rgba(247, 0, 255, 0.15);
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 18px;
          padding: 12px 24px 22px;
        }
        .tv-footer-label {
          font-family: 'SF Pro Rounded Medium', -apple-system, BlinkMacSystemFont, sans-serif;
          font-size: 17px;
          color: rgba(255,255,255,0.7);
          line-height: 1.35;
          text-align: center;
          white-space: normal;
          opacity: 0;
          animation: tv-fade-up 0.2s ease-out 0.05s both;
        }
        .tv-footer-label strong {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          color: #ffffff;
          font-weight: normal;
        }
        .tv-cta {
          font-family: 'SF Pro Rounded Bold', -apple-system, BlinkMacSystemFont, sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          width: 100%;
          max-width: 235px;
          padding: 16px 14px;
          border: none;
          border-radius: 999px;
          background: ${ACCENT};
          color: #fff;
          font-size: 16px;
          font-weight: normal;
          cursor: pointer;
          text-decoration: none;
          transition: filter 0.2s ease, transform 0.15s ease;
        }
        .tv-cta:hover {
          filter: brightness(1.1);
          transform: translateY(-1px);
        }
        .tv-cta-arrow {
          font-size: 1.1em;
          line-height: 1;
        }

        @media (max-width: 380px) {
          .tv-display-name { font-size: 27px; }
          .tv-username { font-size: 18px; }
          .tv-avatar-ring { width: 110px; height: 110px; }
          .tv-card-title { font-size: 17px; }
          .tv-footer-label { font-size: 14px; }
        }
      `}</style>

      <div className="tv-root">
        {!showContent ? (
          <div
            style={{
              minHeight: "100dvh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                border: `3px solid rgba(247, 0, 255, 0.2)`,
                borderTop: `3px solid ${ACCENT}`,
                borderRadius: "50%",
                animation: "test-spin 0.9s linear infinite",
              }}
            />
          </div>
        ) : (
          <>
            {/* tv-content has a transform animation — footer must stay outside it */}
            <div className="tv-content">
              <div className="tv-topbar">
                <img src={moodIcon} alt="MoodStream" className="tv-topbar-icon" />
                <span className="tv-topbar-title">
                  moodstream.me/{username}
                </span>
              </div>

              <div className="tv-header">
                <img
                  src={avatarSrc}
                  alt={username ? `@${username}` : "Profile"}
                  className="tv-avatar-img"
                  onLoad={(e) => e.target.classList.add("loaded")}
                  onError={(e) => {
                    e.target.src = DEFAULT_AVATAR;
                    e.target.classList.add("loaded");
                  }}
                />
                {name && <h2 className={`tv-display-name tv-label tv-label-d1${labelsVisible ? " visible" : ""}`}>{name}</h2>}
                {username && <p className={`tv-username tv-label tv-label-d2${labelsVisible ? " visible" : ""}`}>@{username}</p>}
              </div>

              <div className="tv-grid">
                {todisplaygallerys.map((ent, index) =>
                  ent.snapshot.public.galleryInfo.postImgURL ? (
                    <div
                      className="tv-card"
                      key={index}
                      onClick={() => {
                        if (ent.snapshot.public) {
                          navigate("/album", {
                            state: {
                              ent: ent.snapshot,
                              galId: ent.galId,
                              profilepic,
                              name,
                              username,
                              userid: params.userId,
                              link,
                            },
                          });
                        }
                      }}
                    >
                      <img
                        className="tv-card-img"
                        src={ent.snapshot.public.galleryInfo.postImgURL}
                        alt={ent.snapshot.public.galleryInfo.name}
                        onLoad={(e) => e.target.classList.add("loaded")}
                      />
                      <div className="tv-card-overlay" />
                      <div className="tv-card-title">
                        {ent.snapshot.public.galleryInfo.name}
                      </div>
                    </div>
                  ) : null
                )}
              </div>
            </div>

            {link && (
              <div className="tv-footer">
                <p className={`tv-footer-label tv-label tv-label-d3${labelsVisible ? " visible" : ""}`}>
                  View <strong>{username}</strong>'s camera roll on MoodStream
                </p>
                <button
                  className="tv-cta"
                  onClick={() => { window.location.href = link; }}
                >
                  Open MoodStream
                  <span className="tv-cta-arrow">→</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
